import {createContext} from "react";
import {GERMAN} from "../actions/language";

export const LanguageContext = createContext({
    language: GERMAN, // Default value
    setLanguage: () => {}, // Placeholder function
});


// WEBPACK FOOTER //
// ./src/context/LanguageContext.js